<!-- CarousalCompTypeThree : Image -->
<template>
  <Carousel :value="contentInfo"
      :numVisible="4"
      :numScroll="1"
      :responsiveOptions="responsiveOptions"
      :orientation = "horizontal"
      :circular="true" :autoplayInterval="5000">
    <template #item="slotProps">
      <div class="single-events-card style2" style="width: 200px;border: solid 1px white;">
        <div class="single-brand">
          <img :src="slotProps.data.image" alt="img">
        </div>
      </div>
    </template>

    </Carousel>
</template>

<script>
import Carousel from "primevue/carousel";
export default {
  name: "CarousalCompTypeThree",
  components: {
    Carousel,
  },
  data() {
    return {
      responsiveOptions: [
        {
          breakpoint: "1024px",
          numVisible: 5,
          numScroll: 5,
        },
        {
          breakpoint: "600px",
          numVisible: 2,
          numScroll: 1,
        },
        {
          breakpoint: "480px",
          numVisible: 1,
          numScroll: 1,
        },
      ],
    };
  },
  props: {
    contentInfo: {
      type: Array,
      required: true,
    },
  },
};
</script>
